// @mui
import { Stack, Button, Typography } from '@mui/material';
import { useUser } from 'src/backoffice-app-code/features/Auth/applications/hooks/useUser';
import { getUserFullName } from 'src/backoffice-app-code/features/Auth/models/User';
// assets
import { DocIllustration } from '../../../assets';

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  const { user } = useUser();
  return (
    <Stack
      spacing={3}
      sx={{ px: 5, pb: 5, mt: 10, width: 1, textAlign: 'center', display: 'block' }}
    >
      <DocIllustration sx={{ width: 1 }} />

      <div>
        <Typography gutterBottom variant="subtitle1">
          {user ? `Hi, ${getUserFullName(user)}` : 'Niste prijavljeni'}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Need help?
          <br /> We&apos;re here for you.
        </Typography>
      </div>
    </Stack>
  );
}
